import { render, staticRenderFns } from "./BindRole.vue?vue&type=template&id=bd712d12&scoped=true&"
import script from "./BindRole.vue?vue&type=script&lang=js&"
export * from "./BindRole.vue?vue&type=script&lang=js&"
import style0 from "./BindRole.vue?vue&type=style&index=0&id=bd712d12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd712d12",
  null
  
)

export default component.exports